<template>
  <dara-container class="d-flex justify-content-center align-items-center h-100 py--xl">
    <dara-modal-warning v-if="showModal" />
    <dara-form v-slot="{ validate }" :submit="submitLogin">
      <div class="text-center mb-3">
        <img
          class="mb-2"
          src="@/assets/images/logo.png"
          alt=""
          width="80" />
        <dara-header size="md">Dara</dara-header>
        <small>{{ $t('please-sign-in') }}</small>
      </div>
      <div class="mb-3">
        <dara-input
          v-model="email"
          type="email"
          :name="$t('email-field')"
          rules="required|email"
          :placeholder="$t('email-address')"
          :focus="true" />
      </div>
      <div class="mb-3">
        <dara-input
          v-model="password"
          :name="$t('password-field')"
          type="password"
          rules="required|min:6"
          :placeholder="$t('password')" />
      </div>
      <div class="mb-3">
        <small class="color--primary cursor--pointer" @click="sendNewPassword">{{ $t('forgot-password') }}</small>
      </div>
      <div v-if="error">
        <div class="alert alert-danger" role="alert">
          {{ error }}
        </div>
      </div>
      <div v-if="info">
        <div class="alert alert-success justify-content-center" role="alert">
          {{ info }}
          <br>
          <strong>{{ $t('check-spam-folder') }}</strong>
        </div>
      </div>
      <div class="d-grid mb-3">
        <dara-button
          class="btn btn-primary"
          native-type="submit"
          @click="validate">
          {{ $t('sign-in') }}
        </dara-button>
      </div>
      <div class="d-grid text-center">
        <p>
          {{ $t('dont-have-an-account') }}
          <router-link class="color--primary" to="/register">{{ $t('register') }}</router-link>
        </p>
      </div>
      <div class="d-grid text-center color--primary">
        <p v-if="language == 'en'" class="cursor--pointer" @click="changeLanguage('pt-br')">Português</p>
        <p v-else class="cursor--pointer" @click="changeLanguage('en')">English</p>
      </div>
    </dara-form>
  </dara-container>
</template>

<script>
import * as authStore from '@/modules/auth/auth.store';
import { passwordLogin, sendNewPassword } from '@/modules/auth/auth.service';
import { goToBasePage } from '@/router/route.service';
import { translate, setLanguage, getCookieLanguage } from '@/services/translate.service';

export default {
  name: 'DaraLoginPage',
  data() {
    return {
      email: '',
      password: '',
      error: null,
      info: null,
      language: 'en',
    };
  },
  computed: {
    showModal() {
      return window.location.host !== 'app.daraknows.com';
    },
  },
  beforeCreate() {
    if (authStore.getters.getToken()) {
      goToBasePage();
    }
  },
  beforeMount() {
    this.changeLanguage(getCookieLanguage());
  },
  methods: {
    submitLogin() {
      this.error = null;
      passwordLogin(this.email, this.password)
        .then(goToBasePage)
        .catch(err => {
          if (err.response.data.errors === 'USER_BLOCKED') {
            this.error = `${translate('this-user-was-blocked')}`;
          } else if (err.response.data.errors === 'USER_DELETED') {
            this.error = `${translate('this-user-was-deleted')}`;
          } else if (err.response.data.errors === 'USER_INCORRECT') {
            this.error = `${translate('email-or-password-incorrect')}`;
          }
        });
    },
    changeLanguage(language) {
      this.language = language;
      setLanguage(language);
    },
    sendNewPassword() {
      if (this.email) {
        if (this.validateEmail(this.email)) {
          this.error = null;
          sendNewPassword(this.email)
            .then(() => {
              this.info = `${translate('the-new-password-was-sent-to')} ${this.email}.`;
            })
            .catch(err => {
              if (err.response.data.errors === 'USER_NOT_FOUND') {
                this.error = `${translate('no-active-user-found')}`;
              }
            });
        } else {
          this.error = `${translate('verify-valid-email')}`;
        }
      } else {
        this.error = `${translate('please-type-your-email')}`;
      }
    },
    validateEmail(email) {
      const re = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
      return re.test(email);
    },
  },
};
</script>
<style scoped>
span {
  width: 320px;
}
</style>
